import { Alert, AlertProps, AlertTitle, Typography } from '@mui/material';
import { ReactNode } from 'react';

export type IncAlertProps = {
  title?: string;
  description?: ReactNode;
} & AlertProps;

export const IncAlert = ({ title, description, ...rest }: IncAlertProps) => {
  return (
    <Alert data-testid="IncAlert" sx={{ my: 2 }} {...rest}>
      {title && <AlertTitle data-testid="IncAlert.Title">{title}</AlertTitle>}
      <Typography data-testid="IncAlert.Description">{description}</Typography>
    </Alert>
  );
};
